import {Device} from 'platform/foundation';
import {currencies, formatCurrencySymbol} from 'platform/locale';
import {match} from 'ts-pattern';

import {CurrencyCodeType} from 'shared/web';

import i18n from '../../../../../i18n/i18n';
import {ChartVariant} from '../types/ChartVariant';

export function getYAxisLabel(
  chartVariant: ChartVariant,
  currencyCode: CurrencyCodeType,
  device: Device
): string | undefined {
  if (device === 'mobile') {
    return undefined;
  }

  return match(chartVariant)
    .with('price', () =>
      i18n.t('entity.statisticsChart.labels.priceInThousands', {
        currencySymbol: formatCurrencySymbol(currencies, currencyCode),
      })
    )
    .with('mileage', () => i18n.t('entity.statisticsChart.labels.mileageInThousands'))
    .with('daysOnStock', () => i18n.t('entity.chartOptions.daysOnStock'))
    .with('featuresLevel', () => i18n.t('entity.statisticsChart.labels.featuresLevel'))
    .with('priceMap', () =>
      i18n.t('entity.statisticsChart.labels.priceInThousands', {
        currencySymbol: formatCurrencySymbol(currencies, currencyCode),
      })
    )
    .with('mapView', () => '')
    .exhaustive();
}
